import * as React from 'react';
import './UpdatePolicyPayout.css';
import { Card } from "react-bootstrap";
import { BeneficiaryPayoutSlider } from "./BeneficiaryPayoutSlider";

interface UpdatePolicyPayoutProps {
    emitHandleAddBeneficiary: any;
    emitHandlePercentageChange: any;
    emitHandleBack: any;
    beneficiary: any;
    selectedBenefit: any;
    emitHandleUpdatePolicyPayout: any;
}

export class UpdatePolicyPayout extends React.Component<UpdatePolicyPayoutProps, any> {

    constructor(props) {
        super(props);
        this.state = {
            updateReminderDismissed: false,
            selectedBenefit: {},
            isInEdit: false,
        }
        
        this.handleAddBeneficiary = this.handleAddBeneficiary.bind(this);
        this.handleBack = this.handleBack.bind(this);
        this.handleSliderChange = this.handleSliderChange.bind(this);
        this.handleUpdatePolicyPayout = this.handleUpdatePolicyPayout.bind(this);
    }
    
    handleAddBeneficiary(e) {
        this.props.emitHandleAddBeneficiary();
    }
    
    handleBack() {
        this.props.emitHandleBack();
    }
    
    handleSliderChange(percentage, beneficiary) {
        percentage = parseInt(percentage, 10);
        this.props.emitHandlePercentageChange({percentage, beneficiary: beneficiary});
    }
    
    handleUpdatePolicyPayout() {
        this.props.emitHandleUpdatePolicyPayout();
    }

    public render() {
        return (
            <Card className="p-4">
                <Card.Title>
                    <h3>Update policy payout</h3>
                    
                </Card.Title>
                <Card.Subtitle>
                    <p>Adjust the sliders to show us what percentage of your policy we should pay out to each of your beneficiaries</p>
                </Card.Subtitle>
                <hr />
                <Card.Body>
                    { this.props.selectedBenefit.beneficiaries.map((beneficiary) => 
                        <div className="row justify-content-between align-items-center mb-4 mb-xs-5 ml-2">
                            <div className="beneficiary-payout__name col-6 col-sm-3 col-md-2 order-1">
                                <h4>{ beneficiary.name }</h4>
                            </div>
                            <div className="beneficiary-payout__slider mr-2 order-3 order-md-2">
                                <BeneficiaryPayoutSlider emitHandleChange={this.handleSliderChange} beneficiary={beneficiary} />
                            </div>
                            <div className="beneficiary-payout__percentage col-6 col-sm-2 col-md-3 order-2 order-md-3">
                                <p>{ beneficiary.percentage }%</p>
                            </div>
                        </div> )}
                        <div className="row justify-content-end align-items-center">
                            <div className="col-6 mt-1">
                                <button className="float-right life-insurance-cover__update-beneficiaries-button btn btn-solid-red mb-3" onClick={this.handleUpdatePolicyPayout} id="EditPolicy">Next</button>
                            </div>
                        </div>
                </Card.Body>
            </Card>
        )
    }
}